import { gql } from "@apollo/client";

export const GET_ACTIVITIES_QUERY = gql`
  query GetActivities(
    $accountId: Int
    $skip: Int
    $take: Int
    $filters: ActivityListFiltersInput
    $sort: ActivityListSortInput
  ) {
    activities(accountId: $accountId, skip: $skip, take: $take, filters: $filters, sort: $sort) {
      total

      activities {
        id
        title
        category
        difficulty
        lastDeliveryTime(accountId: $accountId)
        earliestFutureCallPlan(accountId: $accountId) {
          id
          programWeek
          startDate
          endDate
        }
        activityTypes {
          activityTypeKey
          activityTypeLabel
        }
      }
    }
  }
`;

export const GET_ACTIVITY_TYPES_QUERY = gql`
  query GetActivityTypes {
    activityTypes {
      activityTypeKey
      activityTypeLabel
      displayOrder
    }
  }
`;
